const LoadingOver = ({ children, loading }) => {

  return (
    <div>
      {loading &&
        <div className="loader-container">
          <div className="spinner"></div>
        </div>
      }
      {children}

      <style jsx global>{`
        .loader-container {
          width: 100%;
          height: 100vh;
          position: fixed;
          z-index: 10000;
          background: rgba(0, 0, 0, 0.324) url("/images/commons/gif/loading.gif") center
            no-repeat;
          z-index: 9999999999;
        }
      `}
      </style>
    </div>
  )
}

export default LoadingOver;
